import React, { useState } from 'react';
import emailjs from 'emailjs-com';
import './ContactForm.css';

function ContactForm() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();

    const templateParams = {
      name: name,
      email: email,
      phone: phone,
      to_email: 'nadavbzv3@gmail.com', // Send the email to this address
    };

    emailjs.send('service_5kwalzj', 'YOUR_TEMPLATE_ID', templateParams, 'YOUR_USER_ID')
        .then((response) => {
          alert('הפרטים נשלחו בהצלחה!');
        }, (error) => {
          alert('נכון לעכשיו קיימת תקלה במערכת מוזמנים לצור קשר עכשיו בוואצפ או בפייסבוק');
        });

    // Optionally clear the form fields after submission
    setName('');
    setEmail('');
    setPhone('');
  };

  return (
      <section className="contact-form">
        <form onSubmit={handleSubmit} >
          <div className="form-group">
            <input
                type="text"
                placeholder="שם מלא"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
            />
          </div>
          <div className="form-group">
            <input
                type="email"
                placeholder="אימייל"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
            />
          </div>
          <div className="form-group">
            <input
                type="tel"
                placeholder="טלפון"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                required
            />
          </div>
          <button type="submit">שליחה</button>
        </form>
      </section>
  );
}

export default ContactForm;


// import React, { useState } from 'react';
// import './ContactForm.css';
//
// function ContactForm() {
//   const [name, setName] = useState('');
//   const [email, setEmail] = useState('');
//   const [phone, setPhone] = useState('');
//
//   const handleSubmit = (e) => {
//     e.preventDefault();
//     alert('הפרטים נשלחו בהצלחה!');
//     // Here you would typically send the form data to a server
//   };
//
//   return (
//     <section className="contact-form">
//       <form onSubmit={handleSubmit}>
//         <div className="form-group">
//           <input
//             type="text"
//             placeholder="שם מלא"
//             value={name}
//             onChange={(e) => setName(e.target.value)}
//             required
//           />
//         </div>
//         <div className="form-group">
//           <input
//             type="email"
//             placeholder="אימייל"
//             value={email}
//             onChange={(e) => setEmail(e.target.value)}
//             required
//           />
//         </div>
//         <div className="form-group">
//           <input
//             type="tel"
//             placeholder="טלפון"
//             value={phone}
//             onChange={(e) => setPhone(e.target.value)}
//             required
//           />
//         </div>
//         <button type="submit">שליחה</button>
//       </form>
//     </section>
//   );
// }
//
// export default ContactForm;
